import React from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { handleShowOn } from '../../services/functions';

export const InfoField = props => {
  const { info, formikValues, getFieldCallback } = props;

  return (
    <Typography variant="subtitle" color={info.color || 'green'} style={{ paddingBottom: 7, paddingTop: 7, display: handleShowOn(
      info.show_on, formikValues,
      getFieldCallback(!_.isNil(info.show_on) ? info.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}>
      {!_.isEmpty(info.fa_icon) && !_.isNil(info.fa_icon) && info.fa_icon !== 'null'
        ? <FontAwesomeIcon
          icon={['fas', info.fa_icon]}
          color={info.color || 'green'} />
        : null}
      <div style={{ display: 'inline', marginLeft: 3 }} dangerouslySetInnerHTML={{ __html: info.label }}></div>
    </Typography>
  );
};
